import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '@hypenation/tickets';

@Component({
  selector: 'hypenation-share-ticket-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
  ],
  templateUrl: './share-ticket-modal.component.html',
  styles: [`
    .share-form {
      padding: 8px 0;
    }
    .modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 24px;
    }
  `],
})
export class ShareTicketModalComponent implements OnInit {
  readonly nzModalData = inject<{ ticketUid: string }>(NZ_MODAL_DATA);
  ticketUid!: string;
  
  loading = false;
  validateForm!: FormGroup;

  private readonly fb = inject(FormBuilder);
  private readonly apiService = inject(ApiService);
  private readonly messageService = inject(NzMessageService);
  private readonly modalRef = inject(NzModalRef);

  ngOnInit(): void {
    this.ticketUid = this.nzModalData.ticketUid;
    this.validateForm = this.fb.group({
      recipientEmail: [null, [Validators.required, Validators.email]],
      recipientName: [null, [Validators.required]],
      message: [null],
    });
  }

  submitForm(): void {
    if (this.validateForm.valid) {
      this.loading = true;
      const { recipientEmail, recipientName, message } = this.validateForm.value;
      
      this.apiService.shareTicket(this.ticketUid, { 
        recipientEmail, 
        recipientName, 
        message: message || '' 
      }).subscribe({
        next: () => {
          this.loading = false;
          this.messageService.success('Ticket shared successfully via email!');
          this.modalRef.close();
        },
        error: () => {
          this.loading = false;
          this.messageService.error('Failed to share ticket. Please try again later.');
        },
      });
    } else {
      Object.values(this.validateForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  handleCancel(): void {
    this.modalRef.close();
  }
}
